import React, { useEffect, useState } from 'react'
import {
    Flex,
    MainHeadline,
    Tabs,
    TabsContainer,
    PageFooter,
    PageWrapper,
    ContentWrapper,
    Button,
} from '../../styling/GlobalStyles'
import { NavBar } from '../../components/NavBar/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import { convertToDate, getParams, getUtcMonthRange, getWeekRangeUTC, handlePagination } from 'utils/helpers'
import { AppDispatch, RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { WeeklyDisplay } from './WeeklyDisplay'
import { MonthlyDisplay } from './MonthlyDisplay'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { monthsOptions } from './data'
import { endOfWeek, startOfWeek } from 'date-fns'
import { clearAttendances } from 'features/attendance/attendanceSlice'
import { AttendanceImportModal } from './AttendanceImportModal'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { AttendanceModal } from './AttendanceModal'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'
import { ScheduleNavigation } from 'pages/Shifts/Shifts.styled'
import { useNavigate } from 'react-router-dom'

export const Attendance = () => {
    const [active, setActive] = useState('weekly')
    const { attendance, totalPages } = useSelector((state: RootState) => state.attendance)
    const [params, setParams] = useState<any>(getParams({ location, ap: { dateFrom: getWeekRangeUTC(new Date()).start, dateTo: getWeekRangeUTC(new Date()).end } }))
    const dispatch = useDispatch<AppDispatch>()
    const [importModal, setImportModal] = useState(false)
    const [modal, setModal] = useState({ open: false, value: null })
    const navigate = useNavigate()

    useEffect(() => {
        return () => {
            dispatch(clearAttendances())
        }
    }, [])

    const handleSwitchActive = (a: string) => {
        setActive(a)
        if (a == 'weekly') {
            setParams((prev) => {
                const copy = { ...prev }
                copy.dateFrom = convertToDate(startOfWeek(new Date(), { weekStartsOn: 1 }))
                copy.dateTo = convertToDate(endOfWeek(new Date(), { weekStartsOn: 1 })) // TODO ispitati zasto attendance salje api dva puta
                copy.page = 1
                copy.limit = 30
                return copy
            })
        } else {
            setParams(prev => ({ ...prev, page: 1, ...getUtcMonthRange(new Date().getMonth()) }))
        }
    }

    const handleWeekPick = (from: Date, to: Date) => {
        setParams((prev) => {
            const copy = { ...prev }
            copy.dateFrom = convertToDate(from)
            copy.dateTo = convertToDate(to)
            copy.page = 1
            copy.limit = 30
            return copy
        })
    }


    const handleSelect = (value: ISelectValue) => {
        setParams((prev) => {
            const copy = { ...prev }
            copy.roleId = value.value
            return copy
        })
    }

    const parseRoles = (data: any) => {
        return data.data.map((item: any) => ({ label: item.name, value: item.id }))
    }

    const handleMonth = (m: ISelectValue) => {
        setParams(prev => ({ ...prev, page: 1, ...getUtcMonthRange(m.value) }))
    }

    const filters = [

        {
            type: FilterEnum.SEARCH,
            link: LinkEnum.DEPARTMENTS,
            name: 'Departments',
            state: null,
        },
    ]


    return (
        <>
            <NavBar enableTemporaryManualClosing defaultValue={params.employeeName} filterOptions={filters} input placeholder='Search Attendance...' setParams={setParams} queryName='q' limit={30} />
            <PageWrapper noFooter={totalPages < 2}>
                <Flex center between mb='16' >
                    <MainHeadline>Attendance</MainHeadline>
                    <Flex gap='1rem' >
                        <Button orange onClick={() => navigate('policies')}>Policies</Button>
                        <Button orange onClick={() => navigate('reports')}>Reports</Button>
                        <Button orange onClick={() => setImportModal(true)}>Import</Button>
                    </Flex>
                </Flex>
                <ScheduleNavigation>
                    <TabsContainer >
                        <Tabs mediaQShifts active={active === 'weekly'} onClick={() => handleSwitchActive('weekly')}>Weekly</Tabs>
                        <Tabs mediaQShifts active={active === 'monthly'} onClick={() => handleSwitchActive('monthly')} >Monthly</Tabs>
                    </TabsContainer>
                    <Flex width='100%' gap='1rem' alignEnd justend >
                        <HonestSelectAsyncInput
                            link='roles'
                            placeholder='Search role'
                            name='roleId'
                            labelText='Role'
                            // defaultValue={state?.role?.name}
                            onChange={(value: ISelectValue) => handleSelect(value)}
                            parserFunction={parseRoles}
                            width='300px'
                            nomarg
                        />
                        {active == 'weekly' ? <CalendarInput nomarg labelText='Week' width='300px' week defaultValue={[params.dateFrom, params.dateTo]} onChange={handleWeekPick} /> : <HonestSelectInput width='300px' options={monthsOptions} defaultValue={new Date().getMonth()} onChange={handleMonth} labelText='' nomarg name='month' />}
                    </Flex>
                </ScheduleNavigation>
                <ContentWrapper minus={totalPages > 1 ? '19.5rem' : '15rem'} noPadding>
                    {active == 'weekly' ? <WeeklyDisplay setModal={setModal} attendance={attendance} params={params} /> : <MonthlyDisplay setModal={setModal} attendance={attendance} params={params} />}
                </ContentWrapper>
                {importModal && <AttendanceImportModal active={active} params={params} closeModal={() => setImportModal(false)} />}
            </PageWrapper>
            {modal.open && <AttendanceModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
